import React from 'react';
import ChecklistItemTitle from '../ChecklistItemTItle';
import ChecklistItemDescription from '../ChecklistItemDescription';
import ChecklistItemOptionsType from '../ChecklistItemOptionsType';
import ChecklistItemFootnote from '../ChecklistItemFootnote';

export default function ChecklistItem(props) {
  const { checklistItem, onChange } = props;
  const {
    title,
    description,
    footnote,
    customClass = ''
  } = checklistItem;

  const onHandleChange = values => {
    onChange(values);
  };

  return (
    <div className={`app-checklist-item ${customClass}`}>
      <ChecklistItemTitle title={title} />
      <ChecklistItemDescription description={description} />
      <ChecklistItemOptionsType checklistItem={checklistItem} onChange={onHandleChange} />
      <ChecklistItemFootnote footnote={footnote} />
    </div>
  )
}